/**
 * Created by Languagenut on 22/03/2019.
 */


import React  from 'react';
import {Navbar , Form , Button , Card , Row , Col , Nav , NavDropdown} from 'react-bootstrap'
import {SectionMenu , FavoriteButton} from '../components';
import Timeline from '../components/timeline.js';
import {Assignments , Lessons , Members , Live , Reports} from '../components/classes';
import {ClassesService} from '../services';
import {ClassesStore} from '../store';
import Constants from '../constants.js';


let codes = {
    300:"No Classes Found Adminsitrator",
    301:"No Classes Not Adminsitrator",
    303:"No Students"
}

export default class MissingClasses extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.displayLimit = 5;

        this.state = {
            "errorCode":this.props.match.params.code || '300',
            message:"this is the error message",
            description:"The quick brown fox jumps over the lazy dog is an English-language pangram—a sentence that contains all of the letters of the alphabet. It is commonly used for touch-typing practice, testing typewriters and computer keyboards, displaying examples of fonts, and other applications involving text where the use of all letters in the alphabet is desired. Owing to its brevity and coherence, it has become widely known.",
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.setState({
            "errorCode":this.props.match.params.code || '300',
        });

    }


    getActions(){


        switch(this.state.errorCode)
        {
            case "300":
                return  <div >
                    <Button>Import Students with Classes</Button>&nbsp;&nbsp;<Button>Import Staff with Classes</Button>
                </div>
                break;
        }

        return null;

    }

    render(){

        return <Card className="shadow" body>
                <Row style={{minHeight:"500px"}}>
                    <Col className="align-self-center" md={7}>
                        <div>
                            <h4>Languagenut LTD</h4>
                            <br/>
                            <p><b><strong>{this.state.errorCode}</strong></b>&nbsp;{this.state.message}</p>
                            <br/>
                            <p>{this.state.description}</p>
                        </div>
                        <br/>
                        {this.getActions()}
                    </Col>
                    <Col md={5} className="align-self-center"><center>Image</center></Col>

                </Row>
        </Card>
    }


}